import {
  queryProcessingWorkOrder,
  queryPendingWorkOrder
  // queryAllWorkOrderCount
} from '@/api/workPlace/workOrder'
import { clearStoreChatMsgList } from '@/utils/unReadNum'
const handleQueryParams = orders => {
  const params = {
    reminder: null, //医患姓名
    workOrderId: null, //工单id
    businessType: null //	 工单类型
  }
  switch (orders.searchType) {
    case 1:
      params.reminder = orders.name || null
      break
    case 2:
      params.workOrderId = orders.name || null
      break
    default:
      params.businessType = orders.name || null
      break
  }
  return params
}
/**
 * @description:获取工单数据（处理中/待处理）
 * @return 返回工单列表
 */
export const getListToFirst = async function (store, orders, bench) {
  orders.lastProcessList = []
  // orders.suspendFlag = false
  // 获取工单列表 2-待处理
  let pendList = {}
  try {
    pendList = await queryPendingWorkOrder()
    bench.tabs[0].count = pendList.num
  } catch {
    pendList = {}
    bench.tabs[0].count = null
  }
  // 获取工单列表  3-处理中
  let processList = []
  try {
    const params = handleQueryParams(orders)
    const res = await queryProcessingWorkOrder(params)
    const { processingWorkOrderVOList = [] } = res
    processList = processingWorkOrderVOList || []
    orders.lastProcessList = processList
    bench.tabs[1].count = res.num || 0
    orders.autoNum = res.autoNum || 0
    orders.manualNum = res.manualNum || 0
    orders.workOrderSuspendNumberLimit = res.workOrderSuspendNumberLimit || 0
  } catch {
    processList = []
    bench.tabs[1].count = 0
  }
  store.dispatch('workOrder/setAmount', {
    pendingCount: bench.tabs[0].count,
    processingCount: bench.tabs[1].count,
    key: orders.activeKey
  })
  if (processList.length <= 0) {
    clearStoreChatMsgList()
  }
  // 处理中有选中状态
  bench.isCheckTab = orders.activeKey === 3
  return { pendList, processList }
}
